import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation } from "react-router";
import Navbar from "../Navbar/Navbar";
import "./Main.css";
import config from "../../config/apiConfig";
import { Link } from "react-router-dom";
import RingLoader from "react-spinners/RingLoader";
import { Done, ExpandMore } from "@material-ui/icons";
import audience from "../../icons/audience.png";
import black from "../../black.jpg";
import { useMediaQuery } from "react-responsive";
import Genre from "../Genre/Genre";
import sortDown from "../../icons/sort-down.png";
import { getInfo } from "../../utils/hooks";
import TextUtil from "../../utils/textUtil";
import Select from "./Select/Select";
import Dropdown from "./Dropdown/Dropdown";
import StoryCard from "./StoryCard/StoryCard";
import Welcome from "../Welcome/Welcome";
import ViewedStories from "./ViewedStories/ViewedStories";
import ReactGA from "react-ga";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Main(props) {
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    const article_tag = useQuery().get("article_tag");
    const entity = useQuery().get("entity");
    const person_entity = useQuery().get("person_entity");
    console.log(article_tag, entity);
    const [token, setToken] = useState("");
    const [filterPrefs, setFilterPrefs] = useState({});
    const [hasTimeline, setHasTimeline] = useState(false);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [canLoadMore2, setCanLoadMore2] = useState(true);
    const [currentFilter, setCurrentFilter] = useState(
        Cookies.getJSON("current_filter") ?? {
            genre: [],
            sub_genre: [],
            language: [],
            country: [],
            state: [],
            city: [],
            sentiment: [],
            protagonist: [],
            emotion: [],
        }
    );
    const [storyList, setStoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currCount, setCurrCount] = useState(1);
    const [currCount2, setCurrCount2] = useState(1);
    const [scores, setScores] = useState({});
    const [appliedScores, setAppliedScores] = useState({});
    const [scrapbook, setScrapbook] = useState({});

    const options = [
        { value: 0, label: "Low" },
        { value: 1, label: "Medium" },
        { value: 2, label: "High" },
    ];

    function handleShowMore(e) {
        e.preventDefault();
        setCurrCount(currCount + 1);
    }

    function handleRelevenace(value) {
        ReactGA.event({
            category: "Discover",
            action: "Canged Relavance",
            label: value,
        });
        setScores((s) => ({
            ...s,
            relevance: value !== s.relevance ? value : undefined,
        }));
    }

    function handleVirality(value) {
        ReactGA.event({
            category: "Discover",
            action: "Canged virality",
            label: value,
        });
        setScores((s) => ({
            ...s,
            virality: value !== s.virality ? value : undefined,
        }));
    }

    function handleComplexity(value) {
        ReactGA.event({
            category: "Discover",
            action: "Canged complexity",
            label: value,
        });
        setScores((s) => ({
            ...s,
            complexity: value !== s.complexity ? value : undefined,
        }));
    }

    function handleSustenance(value) {
        ReactGA.event({
            category: "Discover",
            action: "Canged sustenance",
            label: value,
        });
        setScores((s) => ({
            ...s,
            sustenance: value !== s.sustenance ? value : undefined,
        }));
    }

    function applyScoreFilters(e) {
        e.stopPropagation();
        setAppliedScores({ ...scores });
    }

    function resetScoreFilters(e) {
        e.stopPropagation();
        setScores({});
        setAppliedScores({});
    }

    function resetAllFilters() {
        const data = {
            genre: [],
            sub_genre: [],
            language: [],
            country: [],
            state: [],
            city: [],
            sentiment: [],
            protagonist: [],
            emotion: [],
        };
        Cookies.set("current_filter", JSON.stringify(data));
        setCurrentFilter(data);
        setCurrCount(1);
        setCurrCount2(1);
        setCanLoadMore(true);
        setCanLoadMore2(true);
    }

    useEffect(() => {
        fetch(config.BASE_URL + "/idam/get/static/filter_preferences.json")
            .then((response) => response.json())
            .then((resp) => {
                setFilterPrefs(resp);
            });
    }, []);

    useEffect(() => {
        const formData = new FormData();
        const filterJson = {
            genre: currentFilter.genre.toString(),
            subgenre: currentFilter.sub_genre.toString(),
            language: currentFilter.language.toString(),
            country: currentFilter.country.toString(),
            state: currentFilter.state.toString(),
            city: currentFilter.city.toString(),
            protagonist: currentFilter.protagonist.toString(),
            emotion: currentFilter.emotion.toString(),
            sentiment: currentFilter.sentiment.toString(),
            has_timeline: hasTimeline,
            sustenance: appliedScores.sustenance,
            complexity: appliedScores.complexity,
            virality: appliedScores.virality,
            relevance: appliedScores.relevance,
            is_viewed: false,
        };
        if (article_tag) filterJson.article_tag = article_tag;
        if (entity) filterJson.entity = entity;
        if (person_entity) filterJson.person_entity = person_entity;

        formData.append("filters", JSON.stringify(filterJson));
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL +
                "/v1/get/stories?" +
                "climit=" +
                32 +
                "&page=" +
                currCount,
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                if (resp.data.length < 32) {
                    setCanLoadMore(false);
                }
                if (currCount === 1) {
                    setStoryList(resp.data);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify(resp.data)
                    );
                } else {
                    setStoryList([...storyList, ...resp.data]);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify([...storyList, ...resp.data])
                    );
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
        // console.log(filterJson);
    }, [currentFilter, currCount, appliedScores, hasTimeline]);

    function handleChange(e, value, arr) {
        e.stopPropagation();
        ReactGA.event({
            category: "Discover",
            action: "Filter applied on " + e.target.name,
            label: e.target.value,
        });
        if (e.target.name === "timeline") {
            setHasTimeline(!hasTimeline);
            Cookies.set("current_filter", JSON.stringify(currentFilter));
            setCurrentFilter({ ...currentFilter });
            return;
        }
        setCurrCount(1);
        setCurrCount2(1);
        setCanLoadMore(true);
        setCanLoadMore2(true);
        if (!arr) arr = [];
        var ind = -1;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === value) {
                ind = i;
                break;
            }
        }
        if (ind != -1) {
            arr.splice(ind, 1);
        } else {
            arr.push(value);
        }
        Cookies.set("current_filter", JSON.stringify(currentFilter));
        setCurrentFilter({ ...currentFilter });
        console.log(currentFilter);
    }

    function handleScrapbook() {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL + "/v1/get/scrapbook/stories?climit=100",
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                setScrapbook(resp);
            })
            .catch((err) => console.log(err));
    }

    function handleDrop(id) {
        document.getElementById(id)?.classList.toggle("show");
    }

    function getSubGenres() {
        let subGenres = [];
        currentFilter.genre.forEach((g) => {
            subGenres = [
                ...subGenres,
                ...(!!filterPrefs?.data?.sub_genres
                    ? filterPrefs.data.sub_genres.filter(
                          (sub_genre) => sub_genre.genre === g
                      )
                    : []),
            ];
        });
        return subGenres;
    }
    function getStates() {
        let states = [];
        currentFilter.country.forEach((c) => {
            states = [
                ...states,
                ...(!!filterPrefs?.data?.states
                    ? filterPrefs.data.states.filter(
                          (state) => state.country === c
                      )
                    : []),
            ];
        });
        return states;
    }

    return (
        <React.Fragment>
            <Genre />
            <Welcome
                title="The wait is over. Time to make some (typing) noise. Start
                    writing."
                body="StoryBot activated on Crime and Thriller genre. More genre
                    to be added soon!"
            />
            <div id="outer-container">
                <Navbar
                    style={{ boxShadow: "5px 2px 10px #edeaed" }}
                    scrapbook={scrapbook}
                />
                <div
                    className="main__content"
                    id="main"
                    style={{ marginTop: "0" }}
                >
                    {/* {isTabletOrMobile ? (
                    <Menu right>
                        <div className="navbar__left" style={{display:'flex'}}>
                            <div className="navbar__img"></div>
                            <h2 className="logo">Pencil</h2>
                        </div>
                        <a className="navbar__link__active" style={{margin: "40px 0"}}>Discover</a>
                        <a className="navbar__link" style={{margin: "40px 0"}}>Friends</a>
                        <a className="navbar__link" style={{margin: "40px 0"}}>Messages</a>
                    </Menu>
                ):( */}
                    <div className="filters">
                        <h2
                            className="big__heading"
                            style={{ marginLeft: "auto", marginTop: "115px" }}
                        >
                            Hi {getInfo()?.name ?? "User"}, here are some top
                            picks for you!
                        </h2>
                        <div className="filter__dropdowns">
                            <div className="filter__left">
                                <Dropdown
                                    title="Genre"
                                    filterApplied={
                                        currentFilter.genre.length !== 0 ||
                                        currentFilter.sub_genre.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                    contentStyles={{
                                        width:
                                            getSubGenres().length !== 0
                                                ? 320
                                                : 160,
                                    }}
                                >
                                    <div
                                        style={{
                                            display:
                                                getSubGenres().length !== 0
                                                    ? "flex"
                                                    : "block",
                                        }}
                                    >
                                        <div>
                                            {filterPrefs?.data?.genres.map(
                                                (genre) => {
                                                    return (
                                                        <label
                                                            className={
                                                                currentFilter.genre.includes(
                                                                    genre.value
                                                                )
                                                                    ? "check__container selected"
                                                                    : "check__container"
                                                            }
                                                            onClick={(e) =>
                                                                handleChange(
                                                                    e,
                                                                    genre.value,
                                                                    currentFilter.genre
                                                                )
                                                            }
                                                            name="genre"
                                                        >
                                                            <div>
                                                                {genre.name}
                                                            </div>
                                                            {currentFilter.genre.includes(
                                                                genre.value
                                                            ) && (
                                                                <Done className="green_dot" />
                                                            )}
                                                        </label>
                                                    );
                                                }
                                            )}
                                        </div>
                                        {getSubGenres().length !== 0 && (
                                            <div
                                                className="sub__genres"
                                                // id={`sub ${genre.value}`}
                                                style={{
                                                    maxHeight: "200px",
                                                    overflow: "auto",
                                                }}
                                            >
                                                {getSubGenres().map(
                                                    (sub_genre) => {
                                                        return (
                                                            <label
                                                                className={
                                                                    currentFilter.sub_genre.includes(
                                                                        sub_genre.value
                                                                    )
                                                                        ? "check__container selected"
                                                                        : "check__container"
                                                                }
                                                                onClick={(e) =>
                                                                    handleChange(
                                                                        e,
                                                                        sub_genre.value,
                                                                        currentFilter.sub_genre
                                                                    )
                                                                }
                                                                name="sub_genre"
                                                            >
                                                                <div>
                                                                    {
                                                                        sub_genre.name
                                                                    }
                                                                </div>
                                                                {currentFilter.sub_genre.includes(
                                                                    sub_genre.value
                                                                ) && (
                                                                    <Done className="green_dot" />
                                                                )}
                                                            </label>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </Dropdown>
                                <Dropdown
                                    title="Location"
                                    filterApplied={
                                        currentFilter.country.length !== 0 ||
                                        currentFilter.state.length !== 0 ||
                                        currentFilter.city.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                    contentStyles={{
                                        width:
                                            getStates().length !== 0
                                                ? 320
                                                : 160,
                                    }}
                                >
                                    <div
                                        style={{
                                            display:
                                                getStates().length !== 0
                                                    ? "flex"
                                                    : "block",
                                        }}
                                    >
                                        <div>
                                            {filterPrefs?.data?.country.map(
                                                (country) => {
                                                    return (
                                                        <label
                                                            className={
                                                                currentFilter.country.includes(
                                                                    country.value
                                                                )
                                                                    ? "check__container selected"
                                                                    : "check__container"
                                                            }
                                                            onClick={(e) =>
                                                                handleChange(
                                                                    e,
                                                                    country.value,
                                                                    currentFilter.country
                                                                )
                                                            }
                                                            name="country"
                                                        >
                                                            <div>
                                                                {country.name}
                                                            </div>
                                                            {currentFilter.country.includes(
                                                                country.value
                                                            ) && (
                                                                <Done className="green_dot" />
                                                            )}
                                                        </label>
                                                    );
                                                }
                                            )}
                                        </div>
                                        {getStates().length !== 0 && (
                                            <div
                                                className="sub__genres"
                                                style={{
                                                    maxHeight: "200px",
                                                    overflow: "auto",
                                                }}
                                            >
                                                {getStates().length !== 0 && (
                                                    <h4
                                                        style={{
                                                            margin: "10px 0 !important",
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        States
                                                    </h4>
                                                )}
                                                {getStates().map((state) => {
                                                    return (
                                                        <div>
                                                            <div>
                                                                <label
                                                                    className={
                                                                        currentFilter.state.includes(
                                                                            state.value
                                                                        )
                                                                            ? "check__container selected"
                                                                            : "check__container"
                                                                    }
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        handleChange(
                                                                            e,
                                                                            state.value,
                                                                            currentFilter.state
                                                                        )
                                                                    }
                                                                    name="state"
                                                                >
                                                                    <div>
                                                                        {
                                                                            state.name
                                                                        }
                                                                    </div>
                                                                    {currentFilter.state.includes(
                                                                        state.value
                                                                    ) && (
                                                                        <Done className="green_dot" />
                                                                    )}
                                                                </label>
                                                            </div>
                                                            {currentFilter.state.includes(
                                                                state.value
                                                            ) && (
                                                                <div
                                                                    className="sub__genres"
                                                                    style={{
                                                                        maxHeight:
                                                                            "200px",
                                                                        overflow:
                                                                            "auto",
                                                                    }}
                                                                >
                                                                    {currentFilter.state.includes(
                                                                        state.value
                                                                    ) &&
                                                                        filterPrefs?.data?.cities.map(
                                                                            (
                                                                                city
                                                                            ) => {
                                                                                if (
                                                                                    city.state ===
                                                                                    state.value
                                                                                ) {
                                                                                    return (
                                                                                        <label
                                                                                            className={
                                                                                                currentFilter.city.includes(
                                                                                                    city.value
                                                                                                )
                                                                                                    ? "check__container selected"
                                                                                                    : "check__container"
                                                                                            }
                                                                                            onClick={(
                                                                                                e
                                                                                            ) =>
                                                                                                handleChange(
                                                                                                    e,
                                                                                                    city.value,
                                                                                                    currentFilter.city
                                                                                                )
                                                                                            }
                                                                                            name="city"
                                                                                        >
                                                                                            <div>
                                                                                                {
                                                                                                    city.name
                                                                                                }
                                                                                            </div>
                                                                                            {currentFilter.city.includes(
                                                                                                city.value
                                                                                            ) && (
                                                                                                <Done className="green_dot" />
                                                                                            )}
                                                                                        </label>
                                                                                    );
                                                                                }
                                                                            }
                                                                        )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Dropdown>
                                <Dropdown
                                    title={"Language"}
                                    filterApplied={
                                        currentFilter.language.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                >
                                    {filterPrefs?.data?.languages.map(
                                        (language) => {
                                            return (
                                                <label
                                                    className={
                                                        currentFilter.language.includes(
                                                            language.value
                                                        )
                                                            ? "check__container selected"
                                                            : "check__container"
                                                    }
                                                    onClick={(e) =>
                                                        handleChange(
                                                            e,
                                                            language.value,
                                                            currentFilter.language
                                                        )
                                                    }
                                                    name="language"
                                                >
                                                    <div>{language.name}</div>
                                                    {currentFilter.language.includes(
                                                        language.value
                                                    ) && (
                                                        <Done className="green_dot" />
                                                    )}
                                                </label>
                                            );
                                        }
                                    )}
                                </Dropdown>
                                <Dropdown
                                    title={"Sentiment"}
                                    filterApplied={
                                        currentFilter.sentiment.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                >
                                    {filterPrefs?.data?.sentiment?.map(
                                        (sentiment) => {
                                            return (
                                                <label
                                                    className={
                                                        currentFilter.sentiment.includes(
                                                            sentiment.value
                                                        )
                                                            ? "check__container selected"
                                                            : "check__container"
                                                    }
                                                    onClick={(e) =>
                                                        handleChange(
                                                            e,
                                                            sentiment.value,
                                                            currentFilter.sentiment
                                                        )
                                                    }
                                                    name="sentiment"
                                                >
                                                    <div>{sentiment.name}</div>
                                                    {currentFilter.sentiment.includes(
                                                        sentiment.value
                                                    ) && (
                                                        <Done className="green_dot" />
                                                    )}
                                                </label>
                                            );
                                        }
                                    )}
                                </Dropdown>
                                <Dropdown
                                    title={"Emotions"}
                                    filterApplied={
                                        currentFilter.emotion.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                >
                                    {filterPrefs?.data?.emotions?.map(
                                        (emotion) => {
                                            console.log(
                                                currentFilter.emotion,
                                                emotion.value
                                            );
                                            return (
                                                <label
                                                    className={
                                                        currentFilter.emotion.includes(
                                                            emotion.value
                                                        )
                                                            ? "check__container selected"
                                                            : "check__container"
                                                    }
                                                    onClick={(e) =>
                                                        handleChange(
                                                            e,
                                                            emotion.value,
                                                            currentFilter.emotion
                                                        )
                                                    }
                                                    name="emotion"
                                                >
                                                    <div>{emotion.name}</div>
                                                    {currentFilter.emotion.includes(
                                                        emotion.value
                                                    ) && (
                                                        <Done className="green_dot" />
                                                    )}
                                                </label>
                                            );
                                        }
                                    )}
                                </Dropdown>
                                <Dropdown
                                    title={"Protagonist"}
                                    filterApplied={
                                        currentFilter.protagonist.length !== 0
                                    }
                                    styles={{ margin: "12px 0" }}
                                >
                                    {filterPrefs?.data?.protoganist?.map(
                                        (protagonist) => {
                                            return (
                                                <label
                                                    className={
                                                        currentFilter.protagonist.includes(
                                                            protagonist.value
                                                        )
                                                            ? "check__container selected"
                                                            : "check__container"
                                                    }
                                                    onClick={(e) =>
                                                        handleChange(
                                                            e,
                                                            protagonist.value,
                                                            currentFilter.protagonist
                                                        )
                                                    }
                                                    name="protagonist"
                                                >
                                                    <div>
                                                        {protagonist.name}
                                                    </div>
                                                    {currentFilter.protagonist.includes(
                                                        protagonist.value
                                                    ) && (
                                                        <Done className="green_dot" />
                                                    )}
                                                </label>
                                            );
                                        }
                                    )}
                                </Dropdown>
                            </div>
                            <div className="filter__right">
                                <Dropdown
                                    title={
                                        <React.Fragment>
                                            <img src={sortDown} /> Filter by
                                            scores{" "}
                                        </React.Fragment>
                                    }
                                    styles={{ margin: "12px 0" }}
                                    buttonStyles={{
                                        width: "200px",
                                    }}
                                >
                                    <div className="filter_score">
                                        <p>Relevancy</p>
                                        <Select
                                            value={scores.complexity}
                                            onChange={handleComplexity}
                                            options={options}
                                        />
                                    </div>
                                    <div className="filter_score">
                                        <p>Uniqueness</p>
                                        <Select
                                            value={scores.relevance}
                                            onChange={handleRelevenace}
                                            options={options}
                                        />
                                    </div>
                                    <div className="filter_score">
                                        <p>Virality</p>
                                        <Select
                                            value={scores.virality}
                                            onChange={handleVirality}
                                            options={options}
                                        />
                                    </div>
                                    <div className="filter_score">
                                        <p>Sustenance</p>
                                        <Select
                                            value={scores.sustenance}
                                            onChange={handleSustenance}
                                            options={options}
                                        />
                                    </div>
                                    <div style={{ padding: "0 16px" }}>
                                        <div className="horizontal_divider" />
                                        <button
                                            className="seco__btn"
                                            onClick={resetScoreFilters}
                                        >
                                            Reset All
                                        </button>
                                        <button
                                            className="primary__btn"
                                            style={{ marginBottom: 8 }}
                                            onClick={applyScoreFilters}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </Dropdown>
                                <button
                                    className="seco__btn"
                                    onClick={resetAllFilters}
                                >
                                    Reset All
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* )} */}
                    <div className="main__list">
                        <div style={{ height: 32 }}></div>
                        <ViewedStories
                            appliedScores={appliedScores}
                            canLoadMore={canLoadMore2}
                            currCount={currCount2}
                            currentFilter={currentFilter}
                            hasTimeline={hasTimeline}
                            setCanLoadMore={setCanLoadMore2}
                            setCurrCount={setCurrCount2}
                            handleScrapbook={handleScrapbook}
                        />
                        <div style={{ margin: "0 140px" }}>
                            {isLoading && currCount === 1 ? (
                                <RingLoader
                                    color="rgb(81,35,67)"
                                    loading={isLoading}
                                />
                            ) : (
                                <div className="story__sec">
                                    {storyList.length === 0 ? (
                                        <p>No Stories Found.</p>
                                    ) : (
                                        storyList.map((story, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() =>
                                                        props.history.push(
                                                            `/writer/story/${story.id}`
                                                        )
                                                    }
                                                    className="story__title"
                                                >
                                                    <StoryCard
                                                        index={index}
                                                        isRead={story.isViewed}
                                                        isAdded={
                                                            story.isInScrapebook
                                                        }
                                                        onScrapChange={
                                                            handleScrapbook
                                                        }
                                                        image={
                                                            story.images[0]
                                                                ?.link
                                                        }
                                                        score={
                                                            story.story_score
                                                        }
                                                        id={story.id}
                                                        title={story.title}
                                                        isLiked={story.isLiked}
                                                        fb_comments={
                                                            story
                                                                .social_media_scores_details
                                                                ?.fb_comments
                                                        }
                                                        fb_shares={
                                                            story
                                                                .social_media_scores_details
                                                                .fb_shares
                                                        }
                                                        fb_reactions={
                                                            story
                                                                .social_media_scores_details
                                                                ?.fb_reactions
                                                        }
                                                    />
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                            {!isLoading && canLoadMore && (
                                <div
                                    style={{
                                        textAlign: "center",
                                        marginTop: "20px",
                                    }}
                                >
                                    <button
                                        onClick={handleShowMore}
                                        className="borderless__btn"
                                        style={{ margin: "auto" }}
                                    >
                                        Show More <ExpandMore />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Main;
